<template>
  <div class="side-bar-right" v-show="isVisible">
    <!-- 퀵메뉴 (중앙) -->
    <div class="quick-menu">
      <!-- POPUP -->
      <div class="quick-item popup-toggle" @click="togglePopup">
        <span class="toggle-label">POPUP</span>
        <span class="toggle-status">{{ isPopupOpen ? 'OFF' : 'ON' }}</span>
      </div>

      <!-- 관심고객등록 -->
      <router-link to="/reservation/register" class="quick-item">
        <svg class="quick-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0zM12 14c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4z"/>
          <path d="M19 8v6M22 11h-6" stroke-linecap="round"/>
        </svg>
        <span class="quick-text">관심고객<br>등록</span>
      </router-link>

      <!-- 오시는길 -->
      <router-link to="/location/direction" class="quick-item">
        <svg class="quick-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
          <circle cx="12" cy="9" r="2.5"/>
        </svg>
        <span class="quick-text">오시는길</span>
      </router-link>
    </div>

    <!-- 하단: 스크롤 -->
    <div class="scroll-indicator">
      <span class="scroll-label">SCROLL</span>
      <div class="scroll-line-wrap">
        <div class="scroll-line"></div>
      </div>
    </div>
  </div>

  <!-- PC 팝업: 즉시전화 + 관심고객등록 나란히 -->
  <transition name="popup-fade">
    <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
      <div class="popup-dual">
        <button class="popup-close" @click="closePopup">
          <span></span>
          <span></span>
        </button>

        <!-- 즉시전화 카드 (1) -->
        <div class="popup-card card-call">
          <div class="card-inner">
            <div class="call-badge">분양가상한제</div>
            <h2 class="call-title">84타입 6억대</h2>
            <p class="call-sub">신분당선 연장선 프리미엄 기대</p>
            <div class="call-divider"></div>
            <p class="call-status">방문예약 상담접수 진행중</p>
            <div class="call-hero">
              <img :src="heroImg" alt="조감도" class="call-hero-img" />
            </div>
            <a href="tel:1599-9923" class="call-btn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
              </svg>
              <span>바로 전화하기</span>
              <strong>1599-9923</strong>
            </a>
          </div>
        </div>

        <!-- 즉시전화 카드 (2) - 진라면 이벤트 -->
        <div class="popup-card card-call">
          <div class="card-inner">
            <div class="call-badge">사은품 증정</div>
            <h2 class="call-title">진라면 5개입 증정</h2>
            <p class="call-sub">지금 상담신청하고 방문하면</p>
            <div class="call-divider"></div>
            <p class="call-status">방문예약 후 방문시 (소진시까지)</p>
            <div class="call-hero">
              <img :src="jinramenImg" alt="진라면 5개입" class="call-hero-img" />
            </div>
            <a href="tel:1599-9923" class="call-btn">
              <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1v3.49a1 1 0 01-1 1C10.07 22 2 13.93 2 3.01a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.24 1.01l-2.2 2.2z"/>
              </svg>
              <span>바로 전화하기</span>
              <strong>1599-9923</strong>
            </a>
            <router-link to="/reservation/register" class="reserve-btn" @click="closePopup">
              상담신청하기
            </router-link>
          </div>
        </div>

        <!-- 관심고객등록 카드 -->
        <div class="popup-card card-register">
          <div class="card-inner">
            <h3 class="reg-title">관심고객등록</h3>
            <p class="reg-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

            <div v-if="!isSubmitted">
              <form @submit.prevent="submitForm" class="reg-form">
                <div class="reg-field">
                  <label>이름</label>
                  <input type="text" v-model="formData.name" placeholder="이름을 입력하세요" required />
                </div>
                <div class="reg-field">
                  <label>연락처</label>
                  <div class="phone-inputs">
                    <input type="tel" inputmode="numeric" ref="rp1" v-model="formData.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'rp2')" />
                    <span>-</span>
                    <input type="tel" inputmode="numeric" ref="rp2" v-model="formData.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'rp3')" />
                    <span>-</span>
                    <input type="tel" inputmode="numeric" ref="rp3" v-model="formData.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
                  </div>
                </div>
                <div class="reg-field">
                  <label>희망 방문일시</label>
                  <div class="visit-inputs">
                    <div class="visit-field-wrap">
                      <svg class="visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      <input type="date" v-model="formData.visitDay" :min="today" />
                    </div>
                    <div class="visit-field-wrap">
                      <svg class="visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                      <select v-model="formData.visitTime">
                        <option value="">시간 선택</option>
                        <option v-for="t in timeSlots" :key="t" :value="t">{{ t }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <label class="reg-agree">
                  <input type="checkbox" v-model="formData.agree" required />
                  <span class="checkmark"></span>
                  <span>개인정보 수집 및 이용에 동의합니다.</span>
                </label>
                <button type="submit" class="reg-submit" :disabled="isSubmitting">
                  {{ isSubmitting ? '전송 중...' : '상담 신청하기' }}
                </button>
              </form>
            </div>

            <div v-else class="reg-success">
              <div class="success-icon">✓</div>
              <h4>신청이 완료되었습니다</h4>
              <p>빠른 시일 내에 연락드리겠습니다.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import heroImg from '@/assets/조감도.jpg'
import jinramenImg from '@/assets/promo/진라면.jpg'
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'SideBarRight',
  data() {
    return {
      isPopupOpen: true,
      currentSection: 0,
      heroImg,
      jinramenImg,
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      },
      timeSlots: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00']
    }
  },
  computed: {
    isVisible() {
      return this.currentSection === 0
    },
    today() {
      return new Date().toISOString().split('T')[0]
    }
  },
  mounted() {
    window.addEventListener('section-change', this.onSectionChange)
  },
  beforeUnmount() {
    window.removeEventListener('section-change', this.onSectionChange)
  },
  methods: {
    onSectionChange(e) {
      this.currentSection = e.detail
      if (this.currentSection > 0) {
        this.isPopupOpen = false
      }
    },
    togglePopup() {
      this.isPopupOpen = !this.isPopupOpen
    },
    closePopup() {
      this.isPopupOpen = false
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          visitDate: this.formData.visitDay && this.formData.visitTime
            ? `${this.formData.visitDay} ${this.formData.visitTime}`
            : this.formData.visitDay || ''
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_40bc4a03dda1'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    }
  }
}
</script>

<style scoped>
.side-bar-right {
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 999;
  width: 100px;
  background: var(--thehue-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 230px 0 40px;
}

.quick-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 36px;
}

.quick-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.85);
  transition: color 0.2s ease;
  cursor: pointer;
}

.quick-item:hover { color: #fff; }

.toggle-label {
  font-family: var(--font-family2);
  font-size: 15px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 1px;
}

.toggle-status {
  font-family: var(--font-family2);
  font-size: 17px;
  font-weight: 700;
  color: #fff;
}

.quick-icon { width: 44px; height: 44px; }

.quick-text {
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  line-height: 1.4;
  letter-spacing: -0.3px;
}

.scroll-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.scroll-label {
  font-family: var(--font-family2);
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 2px;
  writing-mode: vertical-rl;
}

.scroll-line-wrap {
  width: 1px;
  height: 60px;
  background: rgba(255, 255, 255, 0.15);
  overflow: hidden;
  position: relative;
}

.scroll-line {
  width: 100%;
  height: 30px;
  background: rgba(255, 255, 255, 0.7);
  animation: lineScroll 2s ease-in-out infinite;
}

@keyframes lineScroll {
  0% { transform: translateY(-30px); }
  100% { transform: translateY(60px); }
}

/* ===== PC 팝업 ===== */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.popup-dual {
  position: relative;
  display: flex;
  gap: 20px;
  max-height: 90vh;
}

.popup-close {
  position: absolute;
  top: -48px;
  right: 0;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1;
  transition: background 0.3s ease;
}

.popup-close:hover { background: rgba(255, 255, 255, 0.3); }

.popup-close span {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 18px;
  height: 2px;
  background: #fff;
}

.popup-close span:first-child { transform: translate(-50%, -50%) rotate(45deg); }
.popup-close span:last-child { transform: translate(-50%, -50%) rotate(-45deg); }

/* 카드 공통 */
.popup-card {
  width: 400px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.card-inner {
  padding: 36px 32px 32px;
  text-align: center;
}

/* 즉시전화 카드 */
.call-badge {
  display: inline-block;
  padding: 6px 16px;
  background: var(--thehue-primary);
  color: #fff;
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 700;
  border-radius: 20px;
  margin-bottom: 14px;
}

.call-title {
  font-family: var(--font-pretendard);
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 6px;
  letter-spacing: -0.5px;
}

.call-sub {
  font-family: var(--font-pretendard);
  font-size: 14px;
  color: #888;
}

.call-divider {
  width: 36px;
  height: 2px;
  background: var(--thehue-primary);
  margin: 20px auto;
  opacity: 0.4;
}

.call-status {
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 600;
  color: var(--thehue-primary);
  letter-spacing: 0.5px;
  margin-bottom: 18px;
}

.call-hero {
  margin: 0 -32px;
  overflow: hidden;
}

.call-hero-img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

.call-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin: 24px 0 0;
  padding: 16px 24px;
  background: var(--thehue-primary);
  color: #fff;
  border: none;
  border-radius: 14px;
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.call-btn:hover {
  background: var(--thehue-primary-dark);
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 69, 56, 0.3);
}

.call-btn svg { width: 20px; height: 20px; flex-shrink: 0; }

.call-btn strong {
  font-family: var(--font-paperlogy);
  font-size: 19px;
  font-weight: 700;
}

/* 상담신청 버튼 (전화 버튼 아래) */
.reserve-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 0 0;
  padding: 16px 24px;
  background: #fff;
  color: var(--thehue-primary);
  border: 2px solid var(--thehue-primary);
  border-radius: 14px;
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s ease;
}

.reserve-btn:hover {
  background: var(--thehue-primary);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 69, 56, 0.3);
}

/* 관심고객등록 카드 */
.reg-title {
  font-family: var(--font-pretendard);
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 6px;
}

.reg-desc {
  font-family: var(--font-pretendard);
  font-size: 13px;
  color: #999;
  margin-bottom: 24px;
}

.reg-form {
  text-align: left;
}

.reg-field {
  margin-bottom: 16px;
}

.reg-field label {
  display: block;
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 6px;
}

.reg-field input[type="text"],
.reg-field input[type="tel"] {
  width: 100%;
  padding: 12px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  font-family: var(--font-pretendard);
  font-size: 14px;
  transition: border-color 0.2s ease;
  background: #fafafa;
}

.reg-field input:focus {
  outline: none;
  border-color: var(--thehue-primary);
  background: #fff;
}

.phone-inputs {
  display: flex;
  align-items: center;
  gap: 6px;
}

.phone-inputs input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.phone-inputs span {
  color: #ccc;
  font-size: 14px;
  flex-shrink: 0;
}

.visit-inputs {
  display: flex;
  gap: 8px;
}

.visit-field-wrap {
  flex: 1;
  position: relative;
}

.visit-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 15px;
  height: 15px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.visit-inputs input,
.visit-inputs select {
  width: 100%;
  padding: 12px 14px 12px 36px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  font-family: var(--font-pretendard);
  font-size: 14px;
  transition: border-color 0.2s ease;
  background: #fafafa;
  appearance: none;
}

.visit-inputs input:focus,
.visit-inputs select:focus {
  outline: none;
  border-color: var(--thehue-primary);
  background: #fff;
}

.visit-inputs select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 32px;
  cursor: pointer;
}

.reg-agree {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: var(--font-pretendard);
  font-size: 13px;
  color: #666;
  margin: 20px 0 16px;
}

.reg-agree input[type="checkbox"] { display: none; }

.checkmark {
  width: 18px;
  height: 18px;
  border: 2px solid #ddd;
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.reg-agree input:checked + .checkmark {
  background: var(--thehue-primary);
  border-color: var(--thehue-primary);
}

.reg-agree input:checked + .checkmark::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.reg-submit {
  width: 100%;
  padding: 14px;
  background: var(--thehue-primary);
  border: none;
  border-radius: 12px;
  font-family: var(--font-pretendard);
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;
}

.reg-submit:hover { background: var(--thehue-primary-dark); }
.reg-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.reg-success {
  padding: 40px 0;
  text-align: center;
}

.success-icon {
  width: 56px;
  height: 56px;
  border: 2px solid var(--thehue-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: var(--thehue-primary);
  margin: 0 auto 16px;
}

.reg-success h4 {
  font-family: var(--font-pretendard);
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.reg-success p {
  font-size: 14px;
  color: #999;
}

/* 페이드 */
.popup-fade-enter-active { transition: opacity 0.3s ease; }
.popup-fade-leave-active { transition: opacity 0.25s ease; }
.popup-fade-enter-from, .popup-fade-leave-to { opacity: 0; }

/* 모바일: 숨김 */
@media (max-width: 768px) {
  .side-bar-right { display: none; }
  .popup-overlay { display: none; }
}
</style>
